import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "app-blank-page",
  standalone: true,
  template: "",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule]
})
export class BlankPageComponent {}
